module.exports = __webpack_public_path__ + "img/VIC.a628335e.png";